/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaymentMethodListApiResponse } from '../models/PaymentMethodListApiResponse';
import type { SetupIntentApiResponse } from '../models/SetupIntentApiResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClientAppPaymentMethodsService {
    /**
     * Create a SetupIntent to save a payment method
     * @param idempotencyKey Client-generated idempotency key to prevent duplicate SetupIntents
     * @returns SetupIntentApiResponse SetupIntent created
     * @throws ApiError
     */
    public static clientPaymentMethodsControllerSetupV1(
        idempotencyKey: string,
    ): CancelablePromise<SetupIntentApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/client-app/payment-methods/setup',
            query: {
                'idempotencyKey': idempotencyKey,
            },
        });
    }
    /**
     * List saved payment methods
     * @returns PaymentMethodListApiResponse Payment methods fetched
     * @throws ApiError
     */
    public static clientPaymentMethodsControllerListV1(): CancelablePromise<PaymentMethodListApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/client-app/payment-methods',
        });
    }
    /**
     * Remove a saved payment method
     * @param paymentMethodId
     * @returns any Payment method removed
     * @throws ApiError
     */
    public static clientPaymentMethodsControllerRemoveV1(
        paymentMethodId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/client-app/payment-methods/{paymentMethodId}',
            path: {
                'paymentMethodId': paymentMethodId,
            },
        });
    }
    /**
     * Set a payment method as default
     * @param paymentMethodId
     * @returns any Default payment method updated
     * @throws ApiError
     */
    public static clientPaymentMethodsControllerSetDefaultV1(
        paymentMethodId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/client-app/payment-methods/{paymentMethodId}/default',
            path: {
                'paymentMethodId': paymentMethodId,
            },
        });
    }
}
